import React from 'react';
import {Events, EventType} from '../../events/Events';

export enum Appearance {
  LIGHT = 'LIGHT',
  DARK  = 'DARK'
}

export const AppearanceContext = React.createContext<Appearance>(null as any);

export function useAppearance() {
  return React.useContext(AppearanceContext);
}

/**
 * Returns the current appearance.
 */
export const getAppearance = (): Appearance => {
  const appearanceDetectorElement = document.getElementById('appearance-detector') as HTMLElement;
  const breakpointDetectorFontFamily = globalThis.getComputedStyle(appearanceDetectorElement)?.fontFamily;

  if (breakpointDetectorFontFamily?.includes(Appearance.LIGHT)) {
    return Appearance.LIGHT;
  } else if (breakpointDetectorFontFamily.includes(Appearance.DARK)) {
    return Appearance.DARK;
  } else {
    console.warn(`Unknown appearance, defaulting to LIGHT: ${breakpointDetectorFontFamily}`);
    return Appearance.LIGHT;
  }
};

// Keep an eye on changes to the preferred color scheme and publish an event when it changes.
const mediaQuery = globalThis.matchMedia('(prefers-color-scheme: light)');
mediaQuery.addEventListener('change', () => {
  Events.publish(EventType.APPEARANCE_CHANGED);
});
